import React, { useEffect, useState } from 'react'

import { Box, Button, Grid, TextField, Typography } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'

import { LoadingFeedback } from 'components'

import useAuthGuest from 'hooks/useAuthGuest'
import useGuestJourney from 'hooks/useGuestJourney'
import useSnackbar from 'hooks/useSnackbar'

import helpers from 'helpers'
import * as service from 'service'
import { REGISTRATION_METHOD_STEP_INDEX } from 'views/Guests/Journey/Journey'
import useStyles from './styles'

// A etapa de escolha do método de cadastro só existe no fluxo de Inventário de
// IA. Demais módulos seguem direto para o destino original (redirectPath).
const AI_INVENTORY_MODULE = 'ai_inventory'

const ProfileSetupStep = () => {
  const classes = useStyles()
  const snackbar = useSnackbar()
  const { user, setUser } = useAuthGuest()
  const { companyInfo, guestModule, redirectPath, setActiveStep } =
    useGuestJourney()

  const [responsibleName, setResponsibleName] = useState('')
  const [departmentId, setDepartmentId] = useState(null)
  const [departments, setDepartments] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [isFetchingDepartments, setIsFetchingDepartments] = useState(true)

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const response = await service.guestPortal.departments.get({
          perPage: 1000,
          order: 'name ASC',
          minimal: true,
        })
        setDepartments(response?.data?.departments || [])
      } catch {
        snackbar.open({
          message: 'Não foi possível carregar os departamentos.',
          variant: 'error',
        })
      } finally {
        setIsFetchingDepartments(false)
      }
    }
    fetchDepartments()
  }, [])

  const handleSubmit = async () => {
    if (!departmentId) {
      snackbar.open({ message: 'Selecione um departamento.', variant: 'error' })
      return
    }

    setIsLoading(true)
    try {
      await service.guestPortal.profile.update({
        responsibleName,
        departmentId,
      })
      setUser({
        ...user,
        responsibleName: responsibleName || null,
        departmentId,
      })
      if (guestModule === AI_INVENTORY_MODULE) {
        setActiveStep(REGISTRATION_METHOD_STEP_INDEX)
      } else {
        service.history.push(redirectPath)
      }
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Erro ao salvar perfil. Tente novamente.',
        variant: 'error',
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <LoadingFeedback open={isLoading || isFetchingDepartments} />
      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={12} md={8}>
          <Typography color="primary" className={classes.title}>
            {companyInfo?.name}
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography color="primary" className={classes.subtitle}>
            Identificação. Informe seus dados para utilizar o painel de
            Inventário de IA.
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                variant="outlined"
                label="Seu nome (responsável)"
                value={responsibleName}
                onChange={(event) => setResponsibleName(event.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                options={departments}
                getOptionLabel={(option) => option.name || ''}
                getOptionSelected={(option, selected) =>
                  option.id === selected.id
                }
                value={
                  departments.find(
                    (department) => department.id === departmentId,
                  ) || null
                }
                onChange={(event, option) =>
                  setDepartmentId(option?.id || null)
                }
                noOptionsText="Nenhum departamento encontrado"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Departamento *"
                    variant="outlined"
                  />
                )}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={8}>
          <Box className={classes.formFooter}>
            <Button
              variant="contained"
              color="secondary"
              className={classes.submitButton}
              onClick={handleSubmit}
              disabled={!departmentId || isLoading}
            >
              Continuar
            </Button>
          </Box>
        </Grid>
      </Grid>
    </>
  )
}

export default ProfileSetupStep
